module.exports = __webpack_public_path__ + "static/media/logo_admin.8564df35.png";